module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/main-visual-text-86191c64a7f8659ad6c280da252d0db0.png";